export default function (el, etype) {

  if (el.fireEvent) {
   (el.fireEvent('on' + etype));
  } else {
    var evObj = document.createEvent('Events');
    evObj.initEvent(etype, true, false);
    el.dispatchEvent(evObj);
  }
  // usage
  // eventFire(document.getElementById('x'),'click');
}